import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FaExternalLinkAlt, FaArrowUp } from "react-icons/fa"; // Icons for the button
import "./PackageModal.css";
import update from "../../../logo-s.svg";

const PackageModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} className="packageModal">
      <Modal.Header closeButton>
        <Modal.Title>{"Update Your Package"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className="modal-content-wrapper">
          {update && (
            <img
              src={update}
              alt="Package Illustration"
              className="modal-image mb-3"
              style={{ width: "250px", height: "250px", borderRadius: "10px" }}
            />
          )}
          <p className="message">
            {
             "Dear User, it's time to unlock premium features and take your experience to the next level. Click the button below to upgrade now!"
            }
          </p>
        </div>
        <Button
          variant="primary"
          href={"https://aamardokan.online/price"}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 d-flex align-items-center justify-content-center"
        >
          <FaArrowUp className="me-2" />
          Update Package
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default PackageModal;
